export default "__VITE_ASSET__y7ZjmcWr__"